import React from 'react';
import {
  TabMenuItem as UiTabMenuItem,
  TabMenuItemProps,
} from '@make-software/cspr-design';

export const TabMenuItem = (props: TabMenuItemProps) => (
  <UiTabMenuItem
    scale={'xs'}
    lineHeight={'xs'}
    tooltipPaddingScale={1}
    hasOutline
    {...props}
  />
);
